// extracted by mini-css-extract-plugin
export default {"modalHeader":"sba-z","modalContent":"tba-z","formWrapper":"uba-z","fade":"vba-z","fade-in":"wba-z"};